import React from 'react';
import PropTypes from 'prop-types';
import BlockingDialog from 'Components/UI/ConfirmationDialog/BlockingDialog';
import Dialog from './Dialog';

function ConfirmationDialog(props) {
  const { onCancel: onClose } = props;
  return (
    <Dialog {...props} onClose={onClose} />
  );
}

ConfirmationDialog.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string.isRequired,
  alertMessage: PropTypes.string,
  alertType: PropTypes.oneOf(['info', 'error', 'warning', 'success']),
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object,
  loading: PropTypes.bool,
  ConfirmButtonProps: PropTypes.object,
};

ConfirmationDialog.defaultProps = {
  classes: 'Cancel',
  cancelLabel: 'Cancel',
  children: null,
  confirmLabel: 'Yes',
  title: 'Are you sure?',
  className: '',
  alertMessage: null,
  alertType: 'info',
  loading: false,
  ConfirmButtonProps: {},
};

export {
  BlockingDialog,
};

export default ConfirmationDialog;
